// extracted by mini-css-extract-plugin
export default {"parameter":"styles_parameter__0QdJJ","title":"styles_title__ZuQb2"};